// noinspection JSUnusedGlobalSymbols
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs';

import { updateActivities } from 'app/state/activities/activity.actions';
import { initializingMasterDataStore } from 'app/state/master-data/master-data.actions';
import { selectMasterData } from 'app/state/master-data/master-data.selectors';

// noinspection JSUnusedGlobalSymbols
@Injectable()
export class ActivityEffects {
    syncActivitiesWithMasterDataStore$ = createEffect(() =>
        this.actions$.pipe(
            ofType(initializingMasterDataStore),
            switchMap(() => this.store.select(selectMasterData)),
            map((masterData) => updateActivities({ activityList: masterData?.activities ?? [] })),
        ),
    );

    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}
}
